//
// componentsMap 组件Map
// key值必须保持唯一
// 同一目录下的不同组件，尽量在次级目录使用不重复的路径名称，以防遍历处理时出现奇怪的情况（例如不同运行时环境的找不到文件） 20240612
//

export const componentsMap = {
  // example_table: () => import('@/views/table/index'),
  // example_tree: () => import('@/views/tree/index'),
  // form_index: () => import('@/views/form/index'),
  // layout
  layout: () => import('@/layouts/index.vue'),
  // 营销活动
  crowdPackage: () => import('@/views/marketingCtivities/crowdPackage/index.vue'),
  // 人群包
  createCrowdPackage: () => import('@/views/marketingCtivities/crowdPackage/components/createCrowdPackage.vue'),
  // 人群包详情
  viewCrowdPackage: () => import('@/views/marketingCtivities/crowdPackage/components/viewCrowdPackage.vue'),
  // 门店销售报表
  storeSalesReportIndex: () => import('@/views/storeDataReports/storeSalesReportIndex.vue'),
  // 经营分析报表
  businessAnalysisReportIndex: () => import('@/views/storeDataReports/businessAnalysisReportIndex.vue'),
  // 账号通
  accountPassManage: () => import('@/views/accountPass/accountPassIndex.vue'),
  // 表单设计器
  formDesign: () => import('@/views/formDesign/index.vue'),
  // 空导航（only logo）布局容器组件：强制修改密码
  loginedLayout: () => import('@/layouts/loginedLayout.vue'),
  // 强制修改密码
  forceChangePwdComp: () => import('@/views/changePwd/forceChangePwdComp.vue'),
  // 重置密码
  resetPwdComp: () => import('@/views/resetPwd/resetPwdComp.vue'),
  // permission 权限测试页
  // 菜单管理
  menuConfig: () => import('@/views/permission/menuConfig/menuConfig.vue'),
  // 页面权限
  // pagePermission: () => import('@/views/permission/page.vue'),
  // 指令权限
  // directivePermission: () => import('@/views/permission/directive.vue'),
  // 角色权限
  // rolePermission: () => import('@/views/permission/role.vue'),
  // 角色管理
  // roleConfig: () => import('@/views/permission/roleConfig.vue'),
  // 用户管理
  userManage: () => import('@/views/permission/userManage/userManage.vue'),
  // 权限管理
  permissionManage: () => import('@/views/permission/permissionManage/permissionManage.vue'),
  // 角色管理
  roleManage: () => import('@/views/permission/roleManage/roleManage.vue'),
  // 产品管理
  productManage: () => import('@/views/permission/productManage/productManage.vue'),
  // 短信管理
  smsManage: () => import('@/views/notification/smsManageIndex.vue'),
  // 短信模板管理
  smsTmpl: () => import('@/views/notification/components/smsTmpl.vue'),
  // 创建短信模板
  createSmsTmpl: () => import('@/views/notification/components/CreateSmsTmpl.vue'),
  // 创建短信任务
  createSmsTask: () => import('@/views/notification/components/createSmsTask.vue'),
  // 短信供应商管理
  smsSupplierManage: () => import('@/views/notification/components/smsSupplierManage.vue'),
  // Notification Task 任务列表
  notificationTaskList: () => import('@/views/notification/notificationTaskList/index.vue'),
  // 商户分润管理
  merchantProfitSharing: () => import('@/views/merchantManagement/merchantProfitSharing/merchantProfitSharing.vue'),
  // 分润详情
  merchantProfitSharingDetails: () => import('@/views/merchantManagement/merchantProfitSharing/components/merchantProfitSharingDetailsComp.vue'),
  // 商户入驻管理
  merchantSettled: () => import('@/views/merchantManagement/merchantSettled/merchantSettled.vue'),
  // 新建商户
  createMerchantComp: () => import('@/views/merchantManagement/merchantSettled/components/createMerchantComp.vue'),
  // 商户账号管理
  merchantAccountManageComp: () => import('@/views/merchantManagement/merchantSettled/components/merchantAccountManageComp.vue'),
  // 入驻资料提交
  submitSettledDataComp: () => import('@/views/merchantManagement/merchantSettled/components/submitSettledDataComp.vue'),
  // 商户详情
  verifySettledDetailsComp: () => import('@/views/merchantManagement/merchantSettled/components/verifySettledDetailsComp.vue'),
  // 订单管理列表
  orderManageIndex: () => import('@/views/merchantManagement/orderManage/orderManageIndex.vue'),
  // 订单管理详情
  orderManageDetailsComp: () => import('@/views/merchantManagement/orderManage/components/orderManageDetailsComp.vue'),
  // 商户提现列表
  withDrawIndex: () => import('@/views/merchantClient/withDraw/withDrawIndex.vue'),
  // 商户提现详情
  withDrawDetailsComp: () => import('@/views/merchantClient/withDraw/components/withDrawDetailsComp.vue'),
  // 商户账单管理
  merchantBillManage: () => import('@/views/merchantManagement/merchantBillManage/merchantBillManage.vue'),
  // 商户异常账单管理
  merchantAbnormalBillManage: () => import('@/views/merchantManagement/merchantBillManage/merchantAbnormalBillManage.vue'),
  // 发票管理
  invoiceManageIndex: () => import('@/views/invoiceManage/index.vue'),
  // 发票详情
  invoiceManageDetailsComp: () => import('@/views/invoiceManage/components/invoiceManageDetailsComp.vue'),
  // 个人资料
  profileManageIndex: () => import('@/views/profileManage/profileManageIndex.vue'),
  // 个人信息
  // personalInfo: () => import('@/views/profileManage/components/personalInfoComp.vue'),
  // 智慧来酷
  intelligentLecooIndex: () => import('@/views/intelligentLecoo/intelligentLecooIndex.vue'),
  // 二级嵌套容器
  secondNestedComp: () => import('@/layouts/secondNestedComp.vue'),
  jddjFeeSettlementLayout: () => import('@/views/financialModule/jddjFeeSettlement/layouts/jddjFeeSettlementLayout.vue'),
  // 空页面占位（菜单先行、业务页后续接入）
  emptyPageComp: () => import('@/views/common/emptyPage/index.vue'),
  // 顶部tab切换
  organizationManageIndex: () => import('@/views/groupManage/organizationManageIndex.vue'),
  // 组织架构集团
  groupManageComp: () => import('@/views/groupManage/components/groupManageComp.vue'),
  // 组织架构集团数据添加
  createGroupComp: () => import('@/views/groupManage/components/createGroupComp.vue'),
  // 组织架构公司
  companyManageComp: () => import('@/views/groupManage/components/companyManageComp.vue'),
  // 组织架构公司数据添加
  createCompanyComp: () => import('@/views/groupManage/components/createCompanyComp.vue'),
  // 组织架构部门
  departmentManageComp: () => import('@/views/groupManage/components/departmentManageComp.vue'),
  // 组织架构部门数据添加
  createDepartmentComp: () => import('@/views/groupManage/components/createDepartmentComp.vue'),
  // 黑名单管理
  blackListManage: () => import('@/views/blackListManage/blackListManageIndex.vue'),
  // 黑名单新建
  createBlackListComp: () => import('@/views/blackListManage/components/createBlackListComp.vue'),
  // 财务模块-->
  // 基础数据-->财务基础数据
  basicDataFinace: () => import('@/views/financialModule/basicDataManage/basicDataFinace/index.vue'),
  // 基础数据-->财务基础数据-->财务账套信息管理
  finacialAccountInfoManage: () => import('@/views/financialModule/basicDataManage/basicDataFinace/components/finacialAccountInfoManage.vue'),
  // 发票批量红冲 20250725
  invoiceBatchRedPunch: () => import('@/views/financialModule/invoiceBatchRedPunch/index.vue'),
  invoiceBatchRedPunchDetails: () => import('@/views/financialModule/invoiceBatchRedPunch/components/invoiceBatchRedPunchDetails.vue'),
  // 手工调整表
  // 手工调整表-任务列表
  manualAdjustTaskList: () => import('@/views/financialModule/manualAdjustTable/manualAdjustTaskList/index.vue'),
  // 手工调整表-导入文件列表
  manualAdjustImportList: () => import('@/views/financialModule/manualAdjustTable/manualAdjustImportList/index.vue'),
  // 手工调整表-查询列表
  manualAdjustQueryList: () => import('@/views/financialModule/manualAdjustTable/manualAdjustQueryList/index.vue'),
  // AI-GEN-BEGIN - 财务↔产品部分类对照配置（菜单 component=fmsCwbcpbConfig）
  fmsCwbcpbConfig: () => import('@/views/financialModule/manualAdjustTable/cwb2cpbConfig/index.vue'),
  // AI-GEN-END
  // 应收核算
  // 应收核算-任务列表
  accountsReceivableTaskList: () => import('@/views/financialModule/accountsReceivable/accountsReceivableTaskList/index.vue'),
  // 应收核算-导入文件列表
  accountsReceivableImportList: () => import('@/views/financialModule/accountsReceivable/accountsReceivableImportList/index.vue'),
  // 应收核算-查询列表
  accountsReceivableQueryList: () => import('@/views/financialModule/accountsReceivable/accountsReceivableQueryList/index.vue'),
  // AI-GEN-BEGIN - LEC-30 应收模板配置（菜单 component=accountsReceivableTemplateConfig）
  accountsReceivableTemplateConfig: () => import('@/views/financialModule/accountsReceivable/accountsReceivableTemplateConfig/index.vue'),
  // AI-GEN-END
  // 联想邮件发送-发送记录列表
  lenovoMailSendList: () => import('@/views/financialModule/lenovoMailSend/mailSendList/index.vue'),
  // AI-GEN-BEGIN - 联想邮件-收件人信息维护
  // 联想邮件-收件人群组列表
  lenovoMailRecipientGroupList: () => import('@/views/financialModule/lenovoMailSend/mailRecipientGroupList/index.vue'),
  // 后端菜单 component=mailRecipientGroups
  mailRecipientGroups: () => import('@/views/financialModule/lenovoMailSend/mailRecipientGroupList/index.vue'),
  // 联想邮件-某群收件人明细
  lenovoMailRecipientGroupRecipients: () => import('@/views/financialModule/lenovoMailSend/mailRecipientGroupRecipients/index.vue'),
  // AI-GEN-END
  // AI-GEN-BEGIN - LEC-56 订单匹配规则配置（菜单 component=orderMatchRules）
  orderMatchRules: () => import('@/views/financialModule/lenovoMailSend/orderMatchRules/index.vue'),
  orderMatchRulesDetail: () => import('@/views/financialModule/lenovoMailSend/orderMatchRules/detail.vue'),
  orderMatchRulesBuDictionary: () => import('@/views/financialModule/lenovoMailSend/orderMatchRules/buDictionary.vue'),
  // AI-GEN-END
  // 业务对账
  // rpa
  // 上传文件
  rpaUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  bsrUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  // AI-GEN-BEGIN - GS 手工表上传处理结果列表（菜单 component 填 gsManualUploadResult，params 可参考 gs_manual_upload_result）
  gsManualUploadResult: () => import('@/views/financialModule/gsManualUploadResult/index.vue'),
  // AI-GEN-END
  // AI-GEN-BEGIN - LEC-39 凭证生成与推送日志（菜单 component 填 voucherDailyLog）
  voucherDailyLog: () => import('@/views/financialModule/voucherDailyLog/index.vue'),
  // 兼容误配：route_name / 路径风格键
  bipVoucherView: () => import('@/views/financialModule/voucherDailyLog/index.vue'),
  BipVoucherView: () => import('@/views/financialModule/voucherDailyLog/index.vue'),
  // AI-GEN-END
  // AI-GEN-BEGIN - 数据传输配置（菜单 component=dataTransferConfig）
  dataTransferConfig: () => import('@/views/financialModule/dataTransferConfig/index.vue'),
  dataTransferConfigIndex: () => import('@/views/financialModule/dataTransferConfig/index.vue'),
  DataTransferConfig: () => import('@/views/financialModule/dataTransferConfig/index.vue'),
  dataTransferConfigCreate: () => import('@/views/financialModule/dataTransferConfig/create.vue'),
  DataTransferConfigCreate: () => import('@/views/financialModule/dataTransferConfig/create.vue'),
  dataTransferConfigEdit: () => import('@/views/financialModule/dataTransferConfig/[id]/edit.vue'),
  DataTransferConfigEdit: () => import('@/views/financialModule/dataTransferConfig/[id]/edit.vue'),
  // AI-GEN-END
  oneUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  twoUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  threeUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  fourUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  fiveUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  sixUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  sevenUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  eightUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  nineUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  tenUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  elevenUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  // AI-GEN-BEGIN - 预留通用上传组件映射（后端尚未接入）
  twelveUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  thirteenUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  fourteenUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  fifteenUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  sixteenUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  seventeenUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  eighteenUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  nineteenUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  twentyUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  twentyOneUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  twentyTwoUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  twentyThreeUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  twentyFourUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  twentyFiveUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  twentySixUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  twentySevenUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  twentyEightUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  twentyNineUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  thirtyUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  thirtyOneUploadComp: () => import('@/views/financialModule/commonUploadFile/index.vue'),
  // AI-GEN-END
  // 文件列表
  bsrFileList: () => import('@/views/financialModule/businessSystemReconciliation/bsrFileList/index.vue'),
  // RAP管理
  rpaManage: () => import('@/views/financialModule/rpa/rpaManage/index.vue'),
  // RAP管理>详情
  rpaManageDetails: () => import('@/views/financialModule/rpa/rpaManage/components/rpaManageDetails.vue'),
  // 凭证结转
  // 京东到家费用结转 - moto 任务列表
  jddjMotoTaskList: () => import('@/views/financialModule/jddjFeeSettlement/jddjMotoTaskList/index.vue'),
  // 京东到家费用结转 - moto 新建任务（4 表上传，独立于 commonUploadFile）
  jddjMotoUpload: () => import('@/views/financialModule/jddjFeeSettlement/jddjMotoUpload/index.vue'),
  // 京东到家费用结转 - moto 任务详情
  jddjMotoTaskDetail: () => import('@/views/financialModule/jddjFeeSettlement/jddjMotoTaskDetail/index.vue'),
  // 京东到家费用结转 - 专送任务列表
  jddjSpecialDeliveryTaskList: () => import('@/views/financialModule/jddjFeeSettlement/jddjSpecialDeliveryTaskList/index.vue'),
  // 京东到家费用结转 - 专送新建任务（4 表上传，独立于 commonUploadFile）
  jddjSpecialDeliveryUpload: () => import('@/views/financialModule/jddjFeeSettlement/jddjSpecialDeliveryUpload/index.vue'),
  // 京东到家费用结转 - 专送任务详情
  jddjSpecialDeliveryTaskDetail: () => import('@/views/financialModule/jddjFeeSettlement/jddjSpecialDeliveryTaskDetail/index.vue'),
  // 京东到家费用结转 - 超链任务列表
  jddjSuperLinkTaskList: () => import('@/views/financialModule/jddjFeeSettlement/jddjSuperLinkTaskList/index.vue'),
  // 京东到家费用结转 - 超链新建任务（4 表上传，独立于 commonUploadFile）
  jddjSuperLinkUpload: () => import('@/views/financialModule/jddjFeeSettlement/jddjSuperLinkUpload/index.vue'),
  // 京东到家费用结转 - 超链任务详情
  jddjSuperLinkTaskDetail: () => import('@/views/financialModule/jddjFeeSettlement/jddjSuperLinkTaskDetail/index.vue'),
  // 凭证列表
  viewVoucherIndex: () => import('@/views/financialModule/viewVoucher/index.vue'),
  // 凭证详情
  voucherDetails: () => import('@/views/financialModule/viewVoucher/components/voucherDetails.vue'),
  // 银行流水
  // bankVoucherIndex: () => import('@/views/financialModule/bankVoucher/index.vue'),
  // 银行流水-任务创建
  bVTaskCreateIndex: () => import('@/views/financialModule/bankVoucher/taskCreate/index.vue'),
  // 银行流水-上传文件
  bVFileUploadIndex: () => import('@/views/financialModule/bankVoucher/fileUpload/index.vue'),
  // 银行流水-余额查询
  bVGetBalanceIndex: () => import('@/views/financialModule/bankVoucher/getBalance/index.vue'),
  // 银行流水-查询银行流水
  bVGetBankFlowIndex: () => import('@/views/financialModule/bankVoucher/getBankFlow/index.vue'),
  // 银行流水-上传文件列表
  bVFileUploadListIndex: () => import('@/views/financialModule/bankVoucher/fileUploadList/index.vue'),
  // AI-GEN-BEGIN - 场景配置路由组件映射（兼容 backend 路由模式）
  // 场景配置列表
  bankSceneConfigIndex: () => import('@/views/bankFlow/bankSceneConfig/index.vue'),
  // 场景配置列表（兼容历史 component key）
  bankSceneConfig: () => import('@/views/bankFlow/bankSceneConfig/index.vue'),
  // 场景配置新增
  bankSceneConfigCreate: () => import('@/views/bankFlow/bankSceneConfig/create.vue'),
  // 场景配置编辑
  bankSceneConfigEdit: () => import('@/views/bankFlow/bankSceneConfig/[id]/edit.vue'),
  // AI-GEN-END
  // AI-GEN-BEGIN - 支付宝/支付场景配置（backend 菜单 component 映射，解决 bank-voucher-index/alipay-scene-config 白屏）
  alipaySceneConfigIndex: () => import('@/views/bankFlow/bankSceneConfig/index.vue'),
  alipaySceneConfig: () => import('@/views/bankFlow/bankSceneConfig/index.vue'),
  paymentSceneConfigUpdateIndex: () => import('@/views/bankFlow/bankSceneConfig/index.vue'),
  paymentSceneConfigUpdate: () => import('@/views/bankFlow/bankSceneConfig/index.vue'),
  alipaySceneConfigCreate: () => import('@/views/bankFlow/bankSceneConfig/create.vue'),
  paymentSceneConfigUpdateCreate: () => import('@/views/bankFlow/bankSceneConfig/create.vue'),
  alipaySceneConfigEdit: () => import('@/views/bankFlow/bankSceneConfig/[id]/edit.vue'),
  paymentSceneConfigUpdateEdit: () => import('@/views/bankFlow/bankSceneConfig/[id]/edit.vue'),
  // AI-GEN-END
  // 基础数据scm-财务结账信息对照
  bDSCheckoutNC: () => import('@/views/financialModule/basicDataSCM/checkoutNC/index.vue'),
  // 基础数据NC：业务单元
  bdncBusinessUnit: () => import('@/views/financialModule/basicDataNC/businessUnit/index.vue'),
  // 基础数据NC：税率
  bdncTaxRate: () => import('@/views/financialModule/basicDataNC/taxRate/index.vue'),
  // 基础数据NC：会计科目-集团
  bdncAccountingSubjectGroup: () => import('@/views/financialModule/basicDataNC/accountingSubjectGroup/index.vue'),
  // 基础数据NC：OA供应商&nc对照
  bdncSupplierMapping: () => import('@/views/financialModule/basicDataNC/supplierMapping/index.vue'),
  // 基础数据NC：OA供应商&客户对照
  bdncCustomerMapping: () => import('@/views/financialModule/basicDataNC/customerMapping/index.vue'),
  // 银行流水-任务结果统计
  taskConclusionStastics: () => import('@/views/financialModule/bankVoucher/taskConclusionStastics/index.vue'),
  // 同步日志-nc同步日志
  slNcSyncLog: () => import('@/views/financialModule/syncLog/ncSyncLog/index.vue'),
  // 手工表-上传
  mdsFileUpload: () => import('@/views/financialModule/manualDataSheet/mdsFileUpload/index.vue'),
  // 手工表-文件列表
  mdsFileUploadList: () => import('@/views/financialModule/manualDataSheet/mdsFileUploadList/index.vue'),
  // 业务招待费
  oaBizExpense: () => import('@/views/financialModule/basicDataOA/oaBizExpense/index.vue'),
  // 预算项目档案
  oaBudgetProject: () => import('@/views/financialModule/basicDataOA/oaBudgetProject/index.vue'),
  // 成本中心档案
  oaCostCenter: () => import('@/views/financialModule/basicDataOA/oaCostCenter/index.vue'),
  // 付款公司档案
  oaPayCompany: () => import('@/views/financialModule/basicDataOA/oaPayCompany/index.vue'),
  // 供应商管理
  oaSupplierManage: () => import('@/views/financialModule/basicDataOA/oaSupplierManage/index.vue'),
  // 券规则管理
  promotionVoucherRule: () => import('@/views/promotionVoucher/promotionVoucherRule/index.vue'),
  // 新增券规则
  createPromotionVoucherRule: () => import('@/views/promotionVoucher/promotionVoucherRule/components/createPromotionVoucherRule.vue'),
  // AI-GEN-BEGIN - 券包管理（券包列表）
  couponWalletManagement: () => import('@/views/promotionVoucher/couponWalletManagement/index.vue'),
  // 新增券包
  createCouponWallet: () => import('@/views/promotionVoucher/couponWalletManagement/components/createCouponWallet.vue'),
  // AI-GEN-END
  // 券管理
  promotionVoucherManage: () => import('@/views/promotionVoucher/promotionVoucherManage/index.vue'),
  // 创建券
  createPromotionVoucher: () => import('@/views/promotionVoucher/promotionVoucherManage/components/createPromotionVoucher.vue'),
  // 优惠券券发放
  releasePromotionVoucher: () => import('@/views/promotionVoucher/releasePromotionVoucher/index.vue'),
  // 新增发放
  createReleasePromotionVoucher: () => import('@/views/promotionVoucher/releasePromotionVoucher/components/createReleasePromotionVoucher.vue'),
  // 发放明细列表
  releasePromotionVoucherDetails: () => import('@/views/promotionVoucher/releasePromotionVoucher/components/releasePromotionVoucherDetails.vue'),
  // 银行信息管理
  bankinfoMaintain: () => import('@/views/financialModule/bankVoucher/bankinfoMaintain/index.vue'),
  // 查看、编辑银行信息
  editBankinfo: () => import('@/views/financialModule/bankVoucher/bankinfoMaintain/components/editBankinfo.vue'),
  // 后返资源管理
  // 后返资源管理：预算案
  budgetCaseIndex: () => import('@/views/postRebate/budgetCase/budgetCaseIndex.vue'),
  // 后返资源管理：创建预算案（单台、非单台）
  editBudgetCaseComp: () => import('@/views/postRebate/budgetCase/components/editBudgetCaseComp.vue'),
  // 后返资源管理：资源包
  resourcePackIndex: () => import('@/views/postRebate/resourcePack/resourcePackManage/resourcePackIndex.vue'),
  // 后返资源管理：资源包-添加资源包
  editResourcePackComp: () => import('@/views/postRebate/resourcePack/resourcePackManage/components/editResourcePackComp.vue'),
  // 后返资源管理：产品部分类资源包
  productCategoriesRPIndex: () => import('@/views/postRebate/resourcePack/productCategoriesResourcePack/productCategoriesRPIndex.vue'),
  // 后返资源管理：结算案
  settlementCaseIndex: () => import('@/views/postRebate/settlementCase/settlementCaseIndex.vue'),
  // 后返资源管理：创建结算案（单台、非单台）
  editSettlementCaseComp: () => import('@/views/postRebate/settlementCase/components/editSettlementCaseComp.vue'),
  // 后返资源管理：待办
  postRebateUpcomingIndex: () => import('@/views/postRebate/postRebateUpcoming/postRebateUpcomingIndex.vue'),
  // 后返资源管理：报表下载中心
  reportCenterIndex: () => import('@/views/postRebate/reportCenter/reportCenterIndex.vue'),
  // 预算案审批
  auditBudgetCaseComp: () => import('@/views/postRebate/budgetCase/components/editBudgetCaseComp.vue'),
  // 结算案审批
  auditSettlementCaseComp: () => import('@/views/postRebate/settlementCase/components/editSettlementCaseComp.vue'),
  // 成本查看
  costViewList: () => import('@/views/costView/index.vue'),
}
